module.exports = __webpack_public_path__ + "img/attendance_icon.41a89484.svg";